export function SMSCompliancePage() {
  return (
    <div className="py-12 bg-cacao-dark">
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
        <h1 className="font-heading text-xl font-semibold text-[#F5F5F5]">SMS Compliance</h1>
        <p className="mt-1.5 text-xs text-cacao-text-tertiary">Last updated: March 2, 2026</p>

        <div className="mt-8 space-y-6 text-sm text-cacao-muted leading-relaxed">
          <section>
            <h2 className="text-sm font-medium text-[#F5F5F5]">SMS Messaging Terms</h2>
            <p className="mt-2">
              Traction Bee may offer SMS-based features in the future. This page outlines our commitment to SMS compliance and best practices.
            </p>
          </section>

          <section>
            <h2 className="text-sm font-medium text-[#F5F5F5]">1. Consent Requirements</h2>
            <p className="mt-2">
              We will only send SMS messages to users who have explicitly opted in to receive them. Consent will be obtained through a clear and conspicuous opt-in process.
            </p>
          </section>

          <section>
            <h2 className="text-sm font-medium text-[#F5F5F5]">2. Message Types</h2>
            <p className="mt-2">If SMS features are enabled, messages may include:</p>
            <ul className="mt-2 list-disc pl-5 space-y-1">
              <li>Account notifications and security alerts</li>
              <li>Lead activity alerts (new leads, warm replies)</li>
              <li>Daily briefing summaries</li>
              <li>System status updates</li>
            </ul>
          </section>

          <section>
            <h2 className="text-sm font-medium text-[#F5F5F5]">3. Message Frequency</h2>
            <p className="mt-2">
              Message frequency will vary based on your preferences and activity. Users can control notification settings at any time.
            </p>
          </section>

          <section>
            <h2 className="text-sm font-medium text-[#F5F5F5]">4. Opt-Out Instructions</h2>
            <p className="mt-2">
              You can opt out of SMS messages at any time by:
            </p>
            <ul className="mt-2 list-disc pl-5 space-y-1">
              <li>Replying STOP to any message</li>
              <li>Updating your notification preferences in Settings</li>
              <li>Contacting support at support@tractionbee.com</li>
            </ul>
          </section>

          <section>
            <h2 className="text-sm font-medium text-[#F5F5F5]">5. Standard Rates Apply</h2>
            <p className="mt-2">
              Message and data rates may apply. Charges depend on your mobile carrier and plan.
            </p>
          </section>

          <section>
            <h2 className="text-sm font-medium text-[#F5F5F5]">6. Supported Carriers</h2>
            <p className="mt-2">
              SMS services are available on most major US carriers including AT&T, T-Mobile, Verizon, and others.
            </p>
          </section>

          <section>
            <h2 className="text-sm font-medium text-[#F5F5F5]">7. TCPA Compliance</h2>
            <p className="mt-2">
              Traction Bee complies with the Telephone Consumer Protection Act (TCPA) and related FCC regulations. We maintain records of consent and honor all opt-out requests immediately.
            </p>
          </section>

          <section>
            <h2 className="text-sm font-medium text-[#F5F5F5]">8. Privacy</h2>
            <p className="mt-2">
              Your phone number and SMS data are protected under our Privacy Policy. We do not share phone numbers with third parties for marketing purposes.
            </p>
          </section>

          <section>
            <h2 className="text-sm font-medium text-[#F5F5F5]">9. Contact Information</h2>
            <p className="mt-2">
              For questions about SMS messaging, contact us at{' '}
              <a href="mailto:support@tractionbee.com" className="text-cacao-gold hover:text-cacao-gold-hover transition-colors">support@tractionbee.com</a>.
            </p>

            <p className="mt-6 text-xs text-cacao-text-tertiary">
              <strong className="text-cacao-muted">Traction Bee</strong><br />
              26565 Agoura Road, Suite 200<br />
              Calabasas, CA 91302 USA
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
